var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlux(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342.171,
    height: 92.972,
    viewBox: "0 0 342.171 92.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1158",
    "data-name": "Rectangle 1158",
    width: 342.171,
    height: 92.972,
    rx: 11.867,
    fill: "#f6f6f6",
    stroke: "rgba(112,112,112,0.3)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12667",
    "data-name": "Group 12667",
    transform: "translate(0 0.344)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1156",
    "data-name": "Rectangle 1156",
    width: 342.171,
    height: 92.284,
    rx: 26.896,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17132",
    "data-name": "Group 17132",
    transform: "translate(92.489 21.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flux_logo_blue_black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    d: "M24.025,0A23.86,23.86,0,1,1,7.047,6.929,23.86,23.86,0,0,1,24.025,0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(10.88 8.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M98.081,180.768l-2.735,1.578-5.865-3.388,2.666-1.54.067-.039.1.059Z",
    transform: "translate(-82.127 -151.818)",
    fill: "#21262e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M75.958,46.036v3.176L70.179,45.88l-1.568-.9-1.568.9L59.7,50.12l-1.57.908v1.866L55.3,51.262l-1.566-.9-1.568.9L49.515,52.8V46.036l13.226-7.63Z",
    transform: "translate(-49.515 -38.406)",
    fill: "#21262e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M128.1,98.023v8.48l-7.345,4.24h-.011l-7.331-4.235V98.023l7.345-4.243Z",
    transform: "translate(-101.653 -83.596)",
    fill: "#21262e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M57.965,125.5v4.877L53.74,132.82l-4.225-2.441V125.5l4.225-2.438Z",
    transform: "translate(-49.515 -107.493)",
    fill: "#21262e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(58.566 8.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M299.051,54.4v8.18H314v5.746H299.051V79.609h-7.477V48.652h24.412V54.4Z",
    transform: "translate(-291.575 -48.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M418.917,48.652h7.2V79.609h-7.2Z",
    transform: "translate(-391.23 -48.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M504.484,81.5v24.826h-6.831v-2.951a10.045,10.045,0,0,1-7.706,3.323c-6.23,0-10.614-3.507-10.614-11.167V81.5h7.2V94.466c0,4.153,1.843,6,5.029,6,3.323,0,5.721-2.122,5.721-6.694V81.5Z",
    transform: "translate(-438.978 -75.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M624.377,106.329l-5.445-7.618-5.618,7.618h-7.852l9.551-12.51L605.785,81.5h8.075l5.271,7.246,5.4-7.246h7.66l-9.232,12.13,9.589,12.694Z",
    transform: "translate(-538.099 -75.379)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17131",
    "data-name": "Group 17131",
    transform: "translate(98.897 5.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79599",
    "data-name": "Path 79599",
    d: "M-2278.32,18696.6v1.984h24.981v-1.984Z",
    transform: "translate(2278.322 -18692.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79598",
    "data-name": "Path 79598",
    d: "M5.4-3.443H1.193V-10.5H2.782v5.766H5.4Zm1.213,0L9.176-10.5h1.885l2.51,7.054H11.838L11.361-4.91H8.8L8.334-3.443ZM9.147-6.155h1.845L10.215-8.6q-.044-.148-.072-.251a2.058,2.058,0,0,1-.047-.267h-.04q-.024.148-.052.256t-.071.245Zm6.029,2.711V-10.5h2.569a3.124,3.124,0,0,1,1.815.448,1.457,1.457,0,0,1,.634,1.265,1.544,1.544,0,0,1-.34.992,1.767,1.767,0,0,1-.864.593v.015a1.69,1.69,0,0,1,1.08.533,1.584,1.584,0,0,1,.4,1.094,1.883,1.883,0,0,1-.692,1.541,2.9,2.9,0,0,1-1.894.569Zm1.589-5.885v1.722h.7a1.173,1.173,0,0,0,.772-.236.8.8,0,0,0,.283-.648.72.72,0,0,0-.288-.628,1.489,1.489,0,0,0-.87-.209Zm0,2.9v1.806h.864a1.325,1.325,0,0,0,.864-.256.854.854,0,0,0,.312-.7A.74.74,0,0,0,18.5-6.2a1.414,1.414,0,0,0-.858-.229ZM21.786-3.91l.66-1.236a4.045,4.045,0,0,0,.922.425,3.012,3.012,0,0,0,.824.111,1.333,1.333,0,0,0,.841-.216.728.728,0,0,0,.267-.6.712.712,0,0,0-.216-.559,1.866,1.866,0,0,0-.8-.328,3.762,3.762,0,0,1-1.717-.768,1.8,1.8,0,0,1-.533-1.388,1.978,1.978,0,0,1,.7-1.528,2.8,2.8,0,0,1,1.945-.624A4.453,4.453,0,0,1,25.7-10.5a4.359,4.359,0,0,1,.954.345l-.6,1.254a3.4,3.4,0,0,0-.768-.327,2.542,2.542,0,0,0-.666-.1,1.276,1.276,0,0,0-.742.187.616.616,0,0,0-.267.533.567.567,0,0,0,.244.492,2.637,2.637,0,0,0,.873.316,3.356,3.356,0,0,1,1.656.777A1.981,1.981,0,0,1,26.9-5.564a2.057,2.057,0,0,1-.7,1.624,3.015,3.015,0,0,1-2.049.62,5.2,5.2,0,0,1-1.224-.155,4.336,4.336,0,0,1-1.133-.436Z",
    transform: "translate(26.673 10.623)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.532
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlux);
export default __webpack_public_path__ + "static/media/flux.1a733e8ea0dbf23271bcc7534d720f9b.svg";
export { ForwardRef as ReactComponent };